export enum AccountSettingsEmailVerifyStatus {
  CONFIRMED = 'confirmed',
  NOT_CONFIRMED = 'email_send'
}

export default AccountSettingsEmailVerifyStatus;
